import { LucideIcon } from "lucide-react";
import React, { createElement, ReactNode } from 'react';

export default function PageHeader({
    title, icon, children = null
}: {
    title: string, icon?: LucideIcon, children?: ReactNode
}) {
    return (
        <header className="mb-5 max-md:px-8 flex justify-between items-center">
            <h1 className="text-4xl font-bold flex items-center gap-2">
                {icon && createElement(icon, { size: 36 })}
                {title}
            </h1>

            {children}
        </header>
    );
}
